import { useContext } from 'react';
import { PUBLISHING_NOTE_KEY } from '../ectdHeadings';
import { EctdVersionNotesContext } from './EctdVersionNotesContext';

const NOTE_CLASS = 'm-0 mb-1.5 text-[12.5px] text-muted';

/**
 * The one-line eCTD v3.2.2 / v4.0 note under a heading, labelled for the submitter's publisher
 * and kept quiet and out of the REGARA box (Task UI1) — nothing unless `EctdRenderer`
 * provides a note for this heading (the U.S. medicinal types, per heading). The first noted
 * heading (the map's first entry: 1.1 Forms) also shows the one key line above its note, once
 * per dossier, in the same quiet style (Task UI2). Lockstep with the PDF: `_with_version_notes`
 * in `backend/services/dossier/ectd_renderer/usa.py` prints the same lines under the same
 * headings.
 */
export function EctdVersionNote({ number }: { number: string }) {
  const notes = useContext(EctdVersionNotesContext);
  const note = notes.get(number);
  if (!note) return null;
  const first = notes.keys().next().value === number;
  return (
    <>
      {first && <p className={NOTE_CLASS}>{PUBLISHING_NOTE_KEY}</p>}
      <p className={NOTE_CLASS}>{note}</p>
    </>
  );
}
